import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { Subscription } from 'rxjs';

import { CmsPlanSwitch } from 'store/cms/models';
import { Cloudinary, Util, XmStore, XmStoreUtil } from 'core/services';
import { CONFIG_TOKEN } from 'core/constants';
import { IXMOptions } from 'core/interfaces';

@Component({
    selector: 'xm-plan-switch-promotions',
    templateUrl: 'plan-switch-promotions.html',
    styleUrls: ['plan-switch-promotions.scss'],
    standalone: false
})
export class XmPlanSwitchPromotions implements OnDestroy, OnInit {
    @Input() public promotionType: string;
    @Input() public promotionContent: string;
    @Input() public BYOPromoContent: string;
    @Input() public UNLPromoContent: string;
    @Input() public resultPage: boolean;
    @Input() public tradeInDDAPromoContent?: string;
    @Input() public isBogoPromoLossForUnl?: boolean;
    @Input() public extendedPromoContent?: string;

    public alertIcon: MediaImageOptions;
    public enablePlanSwitchPromoMultiple: boolean;

    private subscriptions: Subscription[] = [];
    private xmStore: XmStore;

    constructor(xmStore: XmStore, state: StateService, @Inject(CONFIG_TOKEN) config: IXMOptions) {
        Object.assign(this, { xmStore, state, config });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsPlanSwitch>(CmsPlanSwitch), (result: CmsPlanSwitch) => {
            this.alertIcon = {
                mobile: Cloudinary.generateMediaFromCms(result.alertIcon)
            };
        }));
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
